module.exports = __webpack_public_path__ + "static/media/outer_36.66c8293b.jpg";